import { Injectable } from '@angular/core';
import { EmitterService } from "./emitter.service";
@Injectable()
export class FileUploadService {

  public xhrFileUploadStatus:boolean = false;

  constructor(public _emitterService:EmitterService) { }
/**
     * @author Pradeep
     * @param url,input file 
     * @returns uploaded file response
     */
     
public makeFileRequest(url: string, params: Array<string>, files) {    
        return new Promise((resolve, reject) => {
          const formData: any = new FormData();
          const xhr = new XMLHttpRequest();
          for(let i = 0; i < files.length; i++) {
                formData.append("excelfile", files[i], files[i].name);
              //  console.log(files[i])
            }

            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            };

            xhr.upload.onloadstart= (event) => {
                this.xhrFileUploadStatus = true;
            };
            xhr.upload.onloadend = (event) => {
                   this.xhrFileUploadStatus = false;                
            };
            
            xhr.open("POST", url, true);
            //xhr.setRequestHeader("token", localStorage.getItem("token"))
            xhr.setRequestHeader("token", sessionStorage.getItem("token"));
            xhr.send(formData);            
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/services/file-upload.service.ts